export const basicSearchFields = {
  sources: [
    {
      value: 'collection',
      label: 'Collection',
    },
    {
      value: 'sourceNumber',
      label: 'Source Number',
    },
    {
      value: 'callNumber',
      label: 'Call Number',
    },
    {
      value: 'author',
      label: 'Author',
    },
    {
      value: 'title',
      label: 'Title',
    },
    {
      value: 'description',
      label: 'Description',
    },
    {
      value: 'inscription',
      label: 'Inscriptions',
    },
    {
      value: 'msEntries',
      label: 'MS. Music',
    },
  ],
  entries: [
    {
      value: 'collection',
      label: 'Collection',
    },
    {
      value: 'sourceNumber',
      label: 'Source Number',
    },
    {
      value: 'location',
      label: 'Location',
    },
    {
      value: 'title',
      label: 'Title',
    },
    {
      value: 'composer',
      label: 'Composer',
    },
    {
      value: 'vocalPart',
      label: 'Vocal Part/s',
    },
    {
      value: 'key',
      label: 'Key/s',
    },
    {
      value: 'melodicIncipit',
      label: 'Melodic Incipit',
    },
    {
      value: 'textIncipit',
      label: 'Text Incipit',
    },
    {
      value: 'isSecular',
      label: 'Secular',
    },
    {
      value: 'notes',
      label: 'Notes',
    },
  ],
  collections: [
    {
      value: 'collection',
      label: 'Collection',
    },
    {
      value: 'description',
      label: 'Description',
    },
  ],
};
